import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Amplify from 'aws-amplify';

import config from './config/aws';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import './styles/index.css';
import './config/polyfill';

//import registerServiceWorker from './serviceworker/registerServiceWorker';
import WrappedApp from './components/WrappedApp';
import { configure as storeConfigure } from './store/configureStore';

const store = storeConfigure();

Amplify.configure(config.Amplify);

ReactDOM.render(
  <Provider store={store}>
    <WrappedApp />
  </Provider>, document.getElementById('root'));
//registerServiceWorker();
